const initialValue = {
  sortOptions: {
    filterType: null,
    sortType: null,
  },
  filterRules: [],
}

export default function meineAzubis(sortOptions = initialValue) {
  return sortOptions
}
